export default class SpreadsheetFileReader {
	async readFile(file) {
		const { Workbook } = await import('exceljs')
		const workbook = new Workbook()

		const wb = await workbook.xlsx.load(file)
		if (!wb.worksheets?.length) {
			throw new Error(`Spreadsheet couldn't be read. Please ensure that the file contains at least one worksheet`)
		}
		return { worksheets: [...wb.worksheets], filename: file.name }
	}
}
